import "./index.css"
export default function PageOne() {

    return (
        <div className="page1-bg">
        <div class="ms-5 text-light">
            <div>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>

                <h1>Cryptofinance</h1>
                <h1>Empowers Music</h1>
                <h1>Ecosystem</h1>
                <br/>
                <h5>Lepton Music: The Next Generation of Digital <br />Assets and Music Platform</h5>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>

            </div>

        </div>
        </div>
    )

}